import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { Office } from '../../../classes/office';

@Component({
  selector: 'app-gallery-related-office',
  templateUrl: './gallery-related-office.component.html',
  styleUrls: ['./gallery-related-office.component.scss']
})
export class GalleryRelatedOfficeComponent {
  @Input() readonly relatedOffice: Office;
}
